export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/login/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/pages/Register.vue'),
    meta: {
      rule: 'public'
    }
  },
  {
    path: '/complement/:legal_entity_id',
    name: 'complement',
    component: () => import('@/views/apps/register-complement/Complement.vue'),
    props: true,
    meta: {
      layout: 'full',
      pageTitle: 'Complemento de Cadastro',
    }
  },
  {
    path: '/verified',
    name: 'verified',
    component: () => import('@/views/pages/login/Verified.vue'),
    meta: {
      rule: 'public'
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/pages/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    props: true,
    component: () => import('@/views/pages/ResetPassword.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/first-access',
    name: 'first-access',
    props: true,
    component: () => import('@/views/pages/FirstAccess.vue'),
    meta: {
      rule: 'public'
    }
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('@/views/pages/NotAuthorized.vue'),
    meta: {
      rule: 'public'
    }
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/pages/Error404.vue'),
    meta: {
      rule: 'public'
    }
  },
  {
    path: '/invalid-signature',
    name: 'invalid-signature',
    component: () => import('@/views/pages/InvalidSignature.vue'),
    meta: {
      rule: 'public'
    }
  },
  {
    path: '/a2fa',
    name: 'a2fa',
    component: () => import('@/views/pages/login/Login2fa.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: true,
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/version',
    name: 'version',
    component: () => import('@/views/pages/Version.vue'),
    meta: {
      rule: 'public'
    }
  },
  {
    path: '/form-lgpd/:param_encrypt',
    name: 'form-lgpd',
    props: true,
    component: () => import('@/views/apps/lgpd/RequestForm.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/form/due-diligence/:encrypt',
    name: 'form-due-diligence',
    component: () => import('@/views/apps/forms/due-diligence/DueDiligenceForm.vue'),
    props: true,
    meta: {
      pageTitle: 'Formulário de Análise de Fornecedores',
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/form-incident/:param_encrypt',
    name: 'form-incident',
    props: true,
    component: () => import('@/views/apps/incident/RequestFormIncident.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/schedules/confirm/:hash',
    name: 'confirm-schedule',
    props: true,
    component: () => import('@/views/apps/schedules/ScheduleConfirmation.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/ged/public/:param_encrypt',
    name: 'document-public',
    props: true,
    component: () => import('@/views/apps/documents/FormDocumentPublic.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    props: true,
    component: () => import('@/views/pages/Maintenance.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/systematic-intimidation/:param_encrypt',
    name: 'systematic-intimidation',
    props: true,
    component: () => import('@/views/apps/intimidation-form/SystematicIntimidationForm.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/reporting-channel-form/:param_encrypt',
    name: 'reporting-channel-form',
    props: true,
    component: () => import('@/views/apps/reporting-channel/ReportingChannelForm.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/form-protocol-query/:form_type',
    name: 'form-protocol-query',
    props: true,
    component: () => import('@/views/apps/protocol/FormProtocolQuery.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/newsletters/pub/:link',
    name: 'newsletter-public',
    props: true,
    component: () => import('@/views/apps/newsletter/NewsletterPublic.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/drive/pub/sharing/:type/:param_encrypted',
    name: 'drive-public',
    props: true,
    component: () => import('@/views/apps/drive/DrivePublic.vue'),
    meta: {
      layout: 'full',
      rule: 'public',
      pageTitle: 'SECURAMDATA - Drive'
    }
  },
  {
    path: '/portal-cebas/credentialings/pub/:link',
    name: 'portal-cebas-credentialing-public',
    props: true,
    component: () => import('@/views/apps/portal-cebas/credentialing/CredentialingPublic.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
  {
    path: '/portal-cebas/vacancies/pub/:link',
    name: 'portal-cebas-vacancies-public',
    props: true,
    component: () => import('@/views/apps/portal-cebas/vacancies/VacanciesPublic.vue'),
    meta: {
      layout: 'full',
      rule: 'public'
    }
  },
]
